import {ISelectInputOptionsProvider} from '../../components/singleInputComponents/select/selectInput.component';
import {Constants} from '../../../models/constants/marketplace.constants';
import {CodeRepository} from '../../../repositories/code.repository';
import {ICode} from '../../../models/code.model';
import * as Model from '../../../models/models';
import {ErrorInformation} from '../../../core/services/errorRedirectService/errorInformation.model';
import {IErrorRedirectService} from '../../../core/services/errorRedirectService/errorRedirect.service';

export class BusinessTypeGateway {
    private optionsBinding: string;

    public static $inject = ['$q', 'codeRepository', 'errorRedirectService'];

    public constructor(private $q: ng.IQService,
                       private codeRepository: CodeRepository,
                       private errorRedirectService: IErrorRedirectService) {
        this.optionsBinding = 'item.id as item.codeName for item in $ctrl.options';
    }

    public loadBusinessTypes(): ng.IPromise<any> {
        return this.codeRepository.getCodesByCodeType([Constants.BusinessType.CodeTypeId.toString()])
        .then((codeTables: Model.ICodeDictionary) => {
            return codeTables[Constants.BusinessType.CodeTypeId.toString()];
        })
        .catch((reason: string) => {
            const error = new ErrorInformation();
            error.errorMessage = reason;
            error.errorDetails = reason;
            this.errorRedirectService.redirectToErrorState(error);
            return error;
        });
    }

    public getSelectInputOptionsProvider(businessTypes: ICode[]): ISelectInputOptionsProvider {
        return {
            getOptionsBinding: () => this.optionsBinding,
            getOptionsList: () => businessTypes
        };
    }
}